import { combineReducers } from 'redux';

import { reducer as details } from './detailsModule';
import { flatDetailsReducer as flatDetails } from './flatDetailsModule';
import { reducer as price } from './priceModule';
import { reducer as primaryCategoryMapping } from './primaryCategoryMappingModule';

export default combineReducers({
	details,
	flatDetails,
	price,
	primaryCategoryMapping,
});
